import Phrase from '../../libs/translationsUtils/phrase'

const ShowMoreButton = ({ quickLinksLength, itemsPerContainer, showMore, showAll }) => {
  return <div className='content--centered is-hidden-mobile-only'>
    <button
      className='btn--cta m-b-0'
      onClick={showMore}>
      {showAll
        ? <Phrase p='quick.links.show.less' />
        : <Phrase p='quick.links.show.more' count={{ number: quickLinksLength - itemsPerContainer }} />
      }
      <i className={`icon--auto-width icon--caret-${showAll ? 'up' : 'down'} quicklink__caret`} />
    </button>
  </div>
}

export default ShowMoreButton
